import React, { useState } from 'react';
import './ReportModal.css';

const ReportModal = ({ review, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');

  const reasons = [
    'Inappropriate content',
    'Spam',
    'Fake review',
    'Offensive language',
    'Other'
  ];

  const handleSubmit = () => {
    if (!reason) {
      alert('Please select a reason');
      return;
    }
    onSubmit(reason, comments);
  };

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Report Review</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="modal-content">
          <label className="form-label">Reason for reporting</label>
          <div className="radio-group">
            {reasons.map((r, i) => (
              <label key={i} className="radio-option">
                <input
                  type="radio"
                  name="reason"
                  value={r}
                  checked={reason === r}
                  onChange={(e) => setReason(e.target.value)}
                />
                <span>{r}</span>
              </label>
            ))}
          </div>

          {reason === 'Other' && (
            <div className="comments-section">
              <label className="form-label">Additional comments</label>
              <textarea
                className="comments-textarea"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Please provide more details..."
                rows="4"
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="footer-btn cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="footer-btn submit-btn" onClick={handleSubmit}>
            Submit Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;

